// src/pages/MPFlow/components/MPStepper.jsx
import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

const STEPS = [
  { label: 'Perfil' },
  { label: 'Criação' },
  { label: 'Refino' },
  { label: 'Segmentação' },
  { label: 'Turbinar' },
  { label: 'Vendas' },
];

export default function MPStepper({ current, onStepClick }) {
  return (
    <div className="mp-stepper" role="navigation" aria-label="Etapas do fluxo">
      {STEPS.map((s, i) => {
        const idx   = i + 1;
        const done  = idx < current;
        const active = idx === current;
        const canClick = done && typeof onStepClick === 'function';
        return (
          <React.Fragment key={idx}>
            <div
              className={`mp-step ${active ? 'mp-step--active' : ''} ${done ? 'mp-step--done' : ''} ${canClick ? 'mp-step--clickable' : ''}`}
              onClick={canClick ? () => onStepClick(idx) : undefined}
              role={canClick ? 'button' : undefined}
              tabIndex={canClick ? 0 : undefined}
              onKeyDown={canClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') onStepClick(idx); } : undefined}
            >
              <div className="mp-step__dot">
                {done ? <CheckIcon className="icon-xs mp-step-check-anim" /> : idx}
              </div>
              <span className="mp-step__label">{s.label}</span>
            </div>
            {i < STEPS.length - 1 && (
              <div className={`mp-step__line ${done ? 'mp-step__line--done' : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
